import React, {Component} from 'react'
import {render} from 'react-dom'
import Container from './Container'
import LiveContainer from './LiveContainer'
import StatsContainer from './StatsContainer'
import GuestPostContainer from './GuestPostContainer'
import WorldCupContainer from './WorldCupContainer'

// export default class extends Component {
//   render() {
//     return <div>
//       <h2>Welcome to React components</h2>
//     </div>
//   }
// }

const addCss = (fileName) => {
  
  var head = document.head
    , link = document.createElement('link')

  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = fileName

  head.appendChild(link)
}

const loadScripts = (array,callback) =>{
  var loader = function(src,handler){
      var script = document.createElement("script");
      script.src = src;
      script.onload = script.onreadystatechange = function(){
          script.onreadystatechange = script.onload = null;
          handler();
      }
      var head = document.getElementsByTagName("head")[0];
      (head || document.body).appendChild( script );
  };
  (function run(){
      if(array.length!=0){
          loader(array.shift(), run);
      }else{
          callback && callback();
      }
  })();
}

const init = (config) => {

  addCss("//rawgithub.com/Caged/d3-tip/master/examples/example-styles.css")
  loadScripts([
    // "https://d3js.org/d3.v3.min.js",
    // "https://d3js.org/d3-array.v1.min.js",
    // "https://d3js.org/d3-collection.v1.min.js",
    // "https://d3js.org/d3-color.v1.min.js",
    // "https://d3js.org/d3-format.v1.min.js",
    // "https://d3js.org/d3-interpolate.v1.min.js",
    // "https://d3js.org/d3-interpolate.v1.min.js",
    // "https://d3js.org/d3-scale.v1.min.js",
    // "https://cdnjs.cloudflare.com/ajax/libs/d3-tip/0.7.1/d3-tip.min.js",
    // "//cdnjs.cloudflare.com/ajax/libs/socket.io/2.0.4/socket.io.slim.js",
    // "https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.19.3/moment.min.js",
  ],function(){
  
    var css = `
    .d3-tip{ 
      border-radius: 4px;
      background: #FFB300;
      padding: 8px;
    }
    .d3-tip:after {
      box-sizing: border-box;
      display: inline;
      font-size: 10px;
      width: 100%;
      line-height: 1;
      color: #FFB300;
      position: absolute;
      pointer-events: none;
    }
    .tweet-url {
      color: #212121;
    }
    .__viz_feedContent a {
      color: #3F51B5
    }

    table.__viz_wc{
      border-spacing: 0;
      border-collapse: collapse;
    }
    table.__viz_wc td{
      border-right: 1px solid #aeaeae;
      border-bottom: 1px solid #aeaeae;
      margin: 0;
      min-width: 15px;
    }
    table.__viz_wc td:first-child{
      padding-left: 4px;
    }
    table.__viz_wc td:not(:first-child){
      text-align: right;
      padding-right: 4px;
    }
    table.__viz_wc tbody tr:first-child td{
      border-top: 1px solid #aeaeae;
    }
    table.__viz_wc td:last-child{
      border-right: none;
    }
    table.__viz_wc tbody tr:last-child td{
      border-bottom: none;
    }
    `,
    head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style');
    
    style.type = 'text/css';
    if (style.styleSheet){
    style.styleSheet.cssText = css;
    } else {
    style.appendChild(document.createTextNode(css));
    }
    
    head.appendChild(style);
    // render(<Container height={config.height} width={config.width}/>, document.querySelector(config.selector))
    
    // if(config.live_container) {
    //   render(<LiveContainer 
    //     height={config.live_container.height} 
    //     width={config.live_container.width}/>
    //     , document.querySelector(config.live_container.selector)
    //   )
    // }

    // if(config.stats) {
    //   render(<StatsContainer
    //     height={config.stats.height} 
    //     width={config.stats.width}
    //   />, document.querySelector(config.stats.selector))
    // }

    // if(config.worldcup) {
    //   render(<WorldCupContainer
    //     height={config.worldcup.height} 
    //     width={config.worldcup.width}
    //   />, document.querySelector(config.worldcup.selector))
    // }

    if(config.guestpost) {
      render(<GuestPostContainer 
        url={config.guestpost.url}
        showSnippet={config.guestpost.showSnippet}
      />, document.querySelector(config.guestpost.selector))
    }
  });
}

// const initLiveUpdates = (config) => {
//   loadScripts([
//     "//cdnjs.cloudflare.com/ajax/libs/socket.io/2.0.4/socket.io.slim.js"
//   ],function(){

//   })
// }
//https://cdnjs.cloudflare.com/ajax/libs/d3/4.11.0/d3.js


export default {
  init
};


// WEBPACK FOOTER //
// ./src/index.js